import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppLocale from './lngProvider';
import RoutesApp from './routes';
import { RootState } from './store';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  const { locale } = useSelector((state: RootState) => state.setting);

  const currentAppLocale = AppLocale[locale.locale];

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          components: {
            Switch: {
              handleSize: 16.67,
              trackHeight: 20,
              trackMinWidth: 35,
            },
          },
          token: {
            fontFamily: `"Noto Sans JP", sans-serif`,
            colorPrimary: '#0081FF',
            colorText: '#231F20',
            colorBorder: '#EEF0F4',
          },
        }}
        locale={currentAppLocale.antd}
        button={{ autoInsertSpace: false }}
      >
        <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
          <RoutesApp />
        </IntlProvider>
      </ConfigProvider>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        rtl={false}
        draggable={false}
        theme="colored"
      />
    </QueryClientProvider>
  );
};

export default App;
